"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessengerIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Messenger_svg_1 = __importDefault(require("./Messenger.svg"));
/**
 * Messenger Icon.
 * figma link - https://www.figma.com/file/M9VCQnWUmAbbRy9VXOtlwO/Atomic-Icons?node-id=916%3A916
 */
function MessengerIcon() {
    return (0, jsx_runtime_1.jsx)(Messenger_svg_1.default, {});
}
exports.MessengerIcon = MessengerIcon;
//# sourceMappingURL=MessengerIcon.js.map